import HeaderBar from "./HeaderBar";
import '../../styles/style.css'
import { useData } from "./MemberData";
import { useEffect, useState } from "react";

function StatsPage() {
    const { policeMembersData, penitenciarMembersData, academieMembersData } = useData();
    const [comisarSef, setComisarSef] = useState(0);
    const [comisar, setComisar] = useState(0);
    const [subComisar, setSubComisar] = useState(0);
    const [inspector, setInspector] = useState(0);
    const [agentSefPrincipal, setAgentSefPrincipal] = useState(0);
    const [agentPrincipal, setAgentPrincipal] = useState(0);
    const [agent, setAgent] = useState(0);
    const [cadet, setCadet] = useState(0);
    const [certificatHS, setCertificatHS] = useState(0);
    const [certificatMoto, setCertificatMoto] = useState(0);
    const [certificatPilot, setCertificatPilot] = useState(0);
    const [agentiTAT, setAgentiTAT] = useState(0);
    const [agentiDIS, setAgentiDIS] = useState(0);
    const [instructorFTO, setInstructorFTO] = useState(0);
    const [relatiiPublice, setRelatiiPublice] = useState(0);
    const [resurseUmane, setResurseUmane] = useState(0);
    const [agentPaza, setAgentPaza] = useState(0);
    const [agentPazaSef, setAgentPazaSef] = useState(0);
    const [directorPenitenciar, setDirectorPenitenciar] = useState(0);
    const [concediiPolitie, setConcediiPolitie] = useState(0);
    const [concediiPenitenciar, setConcediiPenitenciar] = useState(0);
    const [instructorRadio, setInstructorRadio] = useState(0);
    const [instructorMDT, setInstructorMDT] = useState(0);
    const [instructorMoto, setInstructorMoto] = useState(0);
    const [instructorPilot, setInstructorPilot] = useState(0);
    const [instructorHS, setInstructorHS] = useState(0);

    useEffect(() => {
        const counts = {
            comisarSef: 0, comisar: 0, subComisar: 0, inspector: 0,
            agentSefPrincipal: 0, agentPrincipal: 0, agent: 0, cadet: 0,
            resurseUmane: 0, relatiiPublice: 0, instructorFTO: 0, agentiTAT: 0,
            agentiDIS: 0, instructorPilot: 0, instructorHS: 0, instructorMoto: 0,
            instructorMDT: 0, instructorRadio: 0, certificatHS: 0, certificatMoto: 0,
            certificatPilot: 0, agentPaza: 0, agentPazaSef: 0, directorPenitenciar: 0
        };

        policeMembersData.forEach(element => {
            switch (element.grade) {
                case "COMISAR-SEF": counts.comisarSef++; break;
                case "COMISAR": counts.comisar++; break;
                case "SUB-COMISAR": counts.subComisar++; break;
                case "INSPECTOR": counts.inspector++; break;
                case "AGENT-SEF-PRINCIPAL": counts.agentSefPrincipal++; break;
                case "AGENT-PRINCIPAL": counts.agentPrincipal++; break;
                case "AGENT": counts.agent++; break;
                case "CADET": counts.cadet++; break;
            }

            if (element.functions?.["resurse umane"]) counts.resurseUmane++;
            if (element.functions?.["relatii publice"]) counts.relatiiPublice++;
            if (element.functions?.["instructor FTO"]) counts.instructorFTO++;
            if (element.functions?.["trupele anti-tero"]) counts.agentiTAT++;
            if (element.functions?.["DIS"]) counts.agentiDIS++;
            if (element.functions?.["instructor pilot"]) counts.instructorPilot++;
            if (element.functions?.["instructor HS"]) counts.instructorHS++;
            if (element.functions?.["instructor moto"]) counts.instructorMoto++;
            if (element.functions?.["instructor MDT"]) counts.instructorMDT++;
            if (element.functions?.["instructor radio"]) counts.instructorRadio++;
            if (element.certificates?.["high-speed"]) counts.certificatHS++;
            if (element.certificates?.["moto"]) counts.certificatMoto++;
            if (element.certificates?.["pilot"]) counts.certificatPilot++;
        });

        penitenciarMembersData.forEach(element => {
            switch (element.grade) {
                case "AGENT-PAZA": counts.agentPaza++; break;
                case "AGENT-PAZA-SEF": counts.agentPazaSef++; break;
                case "DIRECTOR-PENITENCIAR": counts.directorPenitenciar++; break;
            }
        })

        setComisarSef(counts.comisarSef);
        setComisar(counts.comisar);
        setSubComisar(counts.subComisar);
        setInspector(counts.inspector);
        setAgentSefPrincipal(counts.agentSefPrincipal);
        setAgentPrincipal(counts.agentPrincipal);
        setAgent(counts.agent);
        setCadet(counts.cadet);
        setResurseUmane(counts.resurseUmane);
        setRelatiiPublice(counts.relatiiPublice);
        setInstructorFTO(counts.instructorFTO);
        setAgentiTAT(counts.agentiTAT);
        setAgentiDIS(counts.agentiDIS);
        setInstructorPilot(counts.instructorPilot);
        setInstructorHS(counts.instructorHS);
        setInstructorMoto(counts.instructorMoto);
        setInstructorMDT(counts.instructorMDT);
        setInstructorRadio(counts.instructorRadio);
        setAgentPaza(counts.agentPaza);
        setAgentPazaSef(counts.agentPazaSef);
        setDirectorPenitenciar(counts.directorPenitenciar);
        setCertificatHS(counts.certificatHS);
        setCertificatMoto(counts.certificatMoto);
        setCertificatPilot(counts.certificatPilot);

    }, [policeMembersData, penitenciarMembersData]); 

    return (
        <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Statistici"/>
            <div className="w-[99%] h-[87%] box-border p-[1%] bg-[#605D5D61] flex items-center justify-center gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                <div className="w-full h-full flex gap-[1%]">
                    <div className="w-[50%] h-[100%] flex flex-col gap-[1%]">
                        <div className="bg-[#323232] w-full h-[25%] rounded-xl flex flex-col items-center">
                            <span className="text-white textSemiBold text-[1.5vw] h-[20%] flex items-center">TOTAL POLIȚIȘTI</span>
                            <span className="text-white textExtraBold text-[6vw] h-[75%] flex items-center">{policeMembersData.length}</span>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">COMISAR-ȘEF</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{comisarSef}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">COMISAR</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{comisar}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">SUB-COMISAR</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{subComisar}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSPECTOR</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{inspector}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENT-ȘEF-PRINCIPAL</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentSefPrincipal}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENT-PRINCIPAL</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentPrincipal}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENT</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agent}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">CADET</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{cadet}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">CERTIFICAT MOTO</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{certificatMoto}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">CERTIFICAT PILOT</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{certificatPilot}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENȚI T.A.T</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentiTAT}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENȚI D.I.S</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentiDIS}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTORI F.T.O</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorFTO}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">RELAȚII PUBLICE</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{relatiiPublice}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">RESURSE UMANE</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{resurseUmane}</span>
                            </div>
                        </div>
                    </div>
                    <div className="w-[50%] h-[100%] flex flex-col gap-[1%]">
                        <div className="bg-[#323232] w-full h-[25%] rounded-xl flex flex-col items-center">
                            <span className="text-white textSemiBold text-[1.5vw] h-[20%] flex items-center">TOTAL PENITENCIAR</span>
                            <span className="text-white textExtraBold text-[6vw] h-[75%] flex items-center">{penitenciarMembersData.length}</span>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENT-PAZĂ</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentPaza}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">AGENT-PAZĂ-ȘEF</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{agentPazaSef}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">DIRECTOR-PENITENCIAR</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{directorPenitenciar}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[50%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">CONCEDII POLIȚIE</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">-</span>
                            </div>
                            <div className="bg-[#323232] w-[50%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">CONCEDII PENITENCIAR</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">-</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTOR RADIO</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorRadio}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTOR MDT</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorMDT}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTOR MOTO</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorMoto}</span>
                            </div>
                        </div>
                        <div className="w-full h-[14%] flex gap-[1%]">
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTOR PILOT</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorPilot}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-white textSemiBold text-[1vw] h-[25%] flex items-center">INSTRUCTOR HS</span>
                                <span className="text-white textExtraBold text-[3.5vw] h-[70%] flex items-center">{instructorHS}</span>
                            </div>
                            <div className="bg-[#323232] w-[33%] h-[100%] rounded-xl flex flex-col items-center">
                                <span className="text-blue-600 textSemiBold text-[1vw] h-[25%] flex items-center">ACADEMIE</span>
                                <span className="text-blue-600 textExtraBold text-[3.5vw] h-[70%] flex items-center">{academieMembersData.length}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatsPage;